<template>
  <v-container class="d-flex flex-column">
    <v-card class="elevation-0">
      <CategoryTitle :category="category" class="mt-0 mb-6 my-lg-6" />
      <v-row no-gutters class="mt-4">
        <v-col cols="12" sm="8">
          <v-card-text class="pa-0">
            <v-form
              v-on:submit.prevent
              ref="form"
              v-model="valid"
              :lazy-validation="lazy"
            >
              <v-text-field
                v-model="email"
                label="Email *"
                required
                outlined
                dense
                clearable
                :rules="requiredRules"
                @keyup.enter="handleResetPasswordRequest"
              ></v-text-field>
            </v-form>
          </v-card-text>
        </v-col>
        <v-col cols="12" sm="4" class="px-0 px-sm-4">
          <v-card-actions class="pa-0">
            <!-- to="/register" -->
            <v-btn
              @click="handleResetPasswordRequest"
              class="reset-button"
              color="primary"
              large
              :block="$vuetify.breakpoint.xs"
              min-width="200"
              height="40"
              depressed
              :loading="loading"
              :disabled="!valid || email.length <= 0"
              >{{ $t("login.submitResetPassword") }}</v-btn
            >
          </v-card-actions>
        </v-col>
      </v-row>
      <div class="mt-2">
        <ResponseMessage :response="response" />
      </div>
    </v-card>
  </v-container>
</template>
<style lang="scss"></style>
<script>
import customService from "@/service/customService";
import ResponseMessage from "@/components/ResponseMessage.vue";
import CategoryTitle from "@/components/category/CategoryTitle";
import {
  requiredValue
  //  isEmail,
  // isLength
} from "~/validator/validationRules";
import category from "~/mixins/category";

export default {
  components: { ResponseMessage, CategoryTitle },
  name: "ResetPasswordRequest",
  mixins: [category],
  data() {
    return {
      email: "",
      valid: true,
      loading: false,
      lazy: true,
      requiredRules: [requiredValue("Digitare l'email")],
      // emailRules: [isEmail()],
      // fidelityRules: [
      //   isLength(13, "La ZONA Card deve essere lunga 13 caratteri")
      // ],
      response: {}
    };
  },
  methods: {
    async handleResetPasswordRequest(e) {
      let _this = this;
      e.preventDefault();
      let mail = _this.email.match(/\S+@\S+\.\S/) ? _this.email : undefined;
      // let fidelity = _this.email.match(/^.[0-9]*$/) ? _this.email : undefined;
      _this.response = {};
      if (_this.valid) {
        _this.loading = true;
        let res = null;
        try {
          res = await customService.getResetPasswordToken(mail);
          if (res.response?.status == 2) {
            _this.$router.push({
              name: "ResetPasswordConfirm",
              params: { message: res.response }
            });
          } else {
            _this.response = res.response;
          }
        } catch (err) {
          console.log(err);
        } finally {
          _this.loading = false;
        }
      }
    },
    resetPage() {
      this.email = "";
      this.response = {};
      this.showForm = true;
    }
  }
};
</script>
